import { IDestroyOptions, Text } from "pixi.js";
import { ButtonWithScaleAnimation } from "../../common/components/ButtonWithScaleAnimation";
import { CommonResourcesPackage } from "../../common/resources/CommonResourcesPackage";
import { SoundsResourcePackageWrapper } from "../../common/resources/SoundsResourcePackageWrapper";
import { IGameController } from "../controllers/IGameController";
import { SceneIndex } from "../../SceneIndex";
import { IFirstTimeExperienceModel } from "../../common/models/IFirstTimeExperienceModel";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { LobbyButtonsTextStyle } from "./LobbyButtonsTextStyle";

export class PiggyButton extends ButtonWithScaleAnimation {
    private static readonly DESCRIPTION_TEXT = 'PIGGY BANK';

    private readonly soundResources: SoundsResourcePackageWrapper;
    private readonly gameController: IGameController;
    private readonly firstTimeExperienceModel: IFirstTimeExperienceModel;
    private readonly logger: ILogger;

    private descriptionText: Text;

    public constructor(
        commonResources: CommonResourcesPackage,
        soundResources: SoundsResourcePackageWrapper,
        gameController: IGameController,
        firstTimeExperienceModel: IFirstTimeExperienceModel,
        logger: ILogger
    ) {
        super(commonResources.assets_common_ui_piggy_piggy_icon_png);
        this.soundResources = soundResources;
        this.gameController = gameController;
        this.firstTimeExperienceModel = firstTimeExperienceModel;
        this.logger = logger;
        this.build();
        this.visible = this.firstTimeExperienceModel.piggyIconInLobby.value;
        this.onUp.add(this.clickHandle, this);
    }

    private build(): void {
        this.descriptionText = new Text(PiggyButton.DESCRIPTION_TEXT, new LobbyButtonsTextStyle());
        this.descriptionText.position.set(24, 157);
        this.addChild(this.descriptionText);
    }

    private async clickHandle(): Promise<void> {
        this.eventMode = "auto";
        try {
            this.soundResources.assets_sounds_Choose_Card_mp3.play();
            await this.gameController.showPopupBySceneIndex(SceneIndex.PIGGY);
        }
        catch (error: unknown) {
            this.logger.error(error);
        } finally {
            this.eventMode = 'static';
        }
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.onUp.remove(this.clickHandle, this);
        super.destroy(options);
    }
}
